import styled from 'styled-components';
export const ResizerRoot = styled.div`
  width: 2px;
  display: flex;
  align-items: center;
  background: #e5e7f1;
  cursor: col-resize;
`;
export const ButtonRoot = styled.div`
  width: 10px;
  height: 30px;
  display: flex;
  z-index: 999;
  margin-left: -5px;
  margin-right: -5px;
  cursor: col-resize;
  background: #e5e7f1;
  flex-grow: 1;
`;
export const ButtonText = styled.div`
  display: inline-block;
  overflow: hidden;
  font-size: 16px;
  letter-spacing: 1px;
  padding-left: 3px;
  line-height: 7px;
  color: #fff;
  z-index: 999;
`;